import { useState, useEffect } from "react";
import { useDisLikesAgainstAJobQuery } from "../graphql/generated/graphql";

const useDisLikesAgainstAJob = (jobId: any) => {
  const [matchs, setMatchs]: any = useState(null);
  const { data, loading, error, refetch } = useDisLikesAgainstAJobQuery({
    variables: {
      jobId: jobId,
    },
    fetchPolicy: "network-only",
  });
  const loadMatches = () => {
    if (!loading && data) {
      // console.log(data.disLikesAgainstAJob)
      setMatchs(data.disLikesAgainstAJob);
    }
  };

  useEffect(() => {
    loadMatches();
  }, [data]);

  // return matchs;
  return { matchs, refetch };
};

export default useDisLikesAgainstAJob;
